import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PurchasesPage } from "@/features/purchases/purchases-page";

export const Route = createFileRoute("/_authenticated/$store/purchases/")({
  validateSearch: z.object({ range: z.enum(["7d", "30d", "90d"]).optional().catch(undefined) }),
  head: () => ({ meta: [{ title: "Purchases · Rogue AI" }] }),
  component: PurchasesPage,
});
